import { API_BASE_URL } from "@/libs/apis/commons";
import { PROFILES } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { ERROR_CODES } from "@/libs/error/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { UserProfile } from "../types";

const PUBLIC_USER_PROFILE_API_BY_SWOOSH_HANDLE = (swooshHandle: string) =>
  `${API_BASE_URL}/users/${swooshHandle}/public`;

export const getPublicProfileDataForSwooshHandle = async (
  swooshHandle: string,
) => {
  return await axios
    .get(PUBLIC_USER_PROFILE_API_BY_SWOOSH_HANDLE(swooshHandle))
    .then(({ data }) => {
      return data;
    });
};

export const useGetPublicUserDataBySwooshHandle = (
  swooshHandle?: string,
  config?: UseQueryOptions<UserProfile, AxiosError<unknown, any>, UserProfile>,
) => {
  const { isLoading, error, data } = useQuery<
    UserProfile,
    AxiosError,
    UserProfile
  >(
    [PROFILES, swooshHandle],
    () => getPublicProfileDataForSwooshHandle(swooshHandle!),
    {
      retry: false,
      enabled: !!swooshHandle,
      useErrorBoundary: ({ response }) =>
        response !== undefined &&
        response?.status >= ERROR_CODES.INTERNAL_ERROR,
      ...config, // to override config properties pass in config
    },
  );

  return { isLoading, error, userProfile: data };
};
